<template>
  <!-- 结算记录 -->
  <div class="wrapper">
    <Table :columns="columns" :data="tableDate" border> </Table>
  </div>
</template>

<script>
import columnTable from "@/components/commons/columnTable";
export default {
  components: {},
  props: {},
  data() {
    return {
      columns: [
        {
          title: "结算类型",
          key: "type",
          align: "center",
        },
        {
          title: "服务费归属",
          key: "belong",
          align: "center",
          render: (h, params) => {
            return h(columnTable, {
              props: {
                tableDate: ["蜡烛", "一级公司", "陈某某", "王某某"],
              },
            });
          },
        },
        {
          title: "归属人类型",
          key: "relation",
          align: "center",
          render: (h, params) => {
            return h(columnTable, {
              props: {
                tableDate: ["商户", "一级机构", "团队长", "团员"],
              },
            });
          },
        },
        {
          title: "产品名称",
          key: "lp",
          align: "center",
          render: (h, params) => {
            return h(columnTable, {
              props: {
                tableDate: [
                  "完美典藏计划",
                  "完美典藏计划",
                  "完美典藏计划",
                  "完美典藏计划",
                ],
              },
            });
          },
        },
        {
          title: "险种名称",
          key: "lp",
          align: "center",
          render: (h, params) => {
            return h(columnTable, {
              props: {
                tableDate: [
                  "完美典藏主险",
                  "完美典藏主险",
                  "完美典藏主险",
                  "完美典藏主险",
                  "完美典藏主险",
                  "完美典藏主险",
                  "完美典藏主险",
                  "完美典藏主险",
                ],
              },
            });
          },
        },
        {
          title: "结算保费（元）",
          key: "lp",
          align: "center",
        },
        {
          title: "服务费比例",
          key: "lp",
          align: "center",
        },
        {
          title: "收入（元）",
          key: "lp",
          align: "center",
        },
        {
          title: "剩余收入（元）",
          key: "lp",
          align: "center",
        },
        {
          title: "结算状态",
          key: "lp",
          align: "center",
        },
        {
          title: "结算日期",
          key: "lp",
          align: "center",
        },
      ],
      tableDate: [
        {
          type: "首期",
        },
        {
          type: "首期",
        },
        {
          type: "首期",
        },
      ],
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.wrapper {
  /deep/ .ivu-table-cell {
    padding-left: 0;
    padding-right: 0;
    height: 100%;
    display: flex;
    color: #3c464f;
    font-size: 14px;
    justify-content: center;
    align-items: center;
  }

  /deep/ .ivu-table-cell {
    line-height: 1;
  }
}
</style>